import styled from 'styled-components';
import { shade, transparentize } from 'polished';

interface ContainerProps {
  isSelected?: boolean;
}

export const Container = styled.button<ContainerProps>`
  background: ${props =>
    props.disabled || !props.isSelected
      ? transparentize(0.4, '#7030a0')
      : '#7030a0'};
  height: 56px;
  border-radius: 16px;
  border: 0;
  padding: 0 16px;
  color: #e7e7ec;
  width: 100%;
  font-weight: 700;
  margin-top: 16px;
  text-transform: uppercase;

  &:hover {
    background: ${props =>
      props.disabled ? transparentize(0.4, '#7030a0') : shade(0.2, '#7030a0')};
  }
`;
